module.exports = __webpack_public_path__ + "img/visa.144572c7.svg";